import { render, staticRenderFns } from "./RasConfigurazionePostiLettoPianiEditComponent.vue?vue&type=template&id=27ed6a53"
import script from "./RasConfigurazionePostiLettoPianiEditComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoPianiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports